import axios from "../../../../axios";

export type RentalInvoiceTemplateData = {
  lineFields: string[];
  separator: string;
};

export type RentalInvoiceTemplateResponse = {
  template: RentalInvoiceTemplateData;
  availableFields: string[];
};

export const getRentalInvoiceTemplate =
  async (): Promise<RentalInvoiceTemplateResponse> => {
    const res = await axios.get("/api/rental-invoice-template");
    return res.data as RentalInvoiceTemplateResponse;
  };

export const saveRentalInvoiceTemplate = async (
  data: RentalInvoiceTemplateData
): Promise<RentalInvoiceTemplateData> => {
  const res = await axios.put("/api/rental-invoice-template", { data });
  return (res.data as { template: RentalInvoiceTemplateData }).template;
};
